export default {
  install(Vue) {
    Vue.prototype.$defaultDataTableFooterProps = {
      itemsPerPageOptions: [5, 10, 30]
    }
  }
}